import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SVGIcon, xIcon, clockIcon } from '@progress/kendo-svg-icons';
import { combineLatest, filter, finalize, startWith, takeUntil } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { AbstractComponent } from 'src/app/shared/components/abstract-component';
import { getTimeDiffShort } from 'src/app/shared/functions/time-diff';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import { ICompareMandatesPaylaod } from '../../../modules/provider-management/interfaces/compare-mandates-payload';
import {
  IAnnualGoalsResposne,
  IMandatesCompareResponse,
  IMandateseAssignmentCompare,
} from '../../../modules/provider-management/interfaces/mandates-compare-response';
import { DashboardPMResponse } from '../../../modules/provider-management/interfaces/pm-dashboard.response';
import { ProviderManagementService } from '../../../modules/provider-management/services/provider-management.service';
import { ICurrentEventData } from 'src/app/modules/provider-management/interfaces/current-event-data';

@Component({
  selector: 'app-schedule-assisstant',
  templateUrl: './schedule-assisstant.component.html',
  styleUrls: ['./schedule-assisstant.component.scss'],
  standalone: false
})
export class ScheduleAssisstantComponent
  extends AbstractComponent
  implements OnInit {
  public xMark: SVGIcon = xIcon;
  public clock: SVGIcon = clockIcon;
  @Input() selectedMandates: any[];
  @Input() studentsSelected: boolean;
  private user: User;
  @Input() scheduleFormDetails: any
  @Input() editSelectedMandates: ICurrentEventData[];
  @Input() studentSk: string;
  @Input() compareMandatesGridView: IMandateseAssignmentCompare[] = [];
  @Input() annualGoalsGridView: IAnnualGoalsResposne[] = [];
  public loading: boolean = true;
  public schedulesFormGroup: FormGroup;
  public duration: string = '0m';
  readonly indexNumberOne: number = 1;
  @Input() meetingSk: string;
  @Input() public isNew: boolean = undefined;
  editMandateIds: string[];
  editAssessments: any;
  @Input() selectionCompare: boolean
  @Input() selecteStudentdMandates: any[];
  @Input() isEditingSession: boolean;

  @Input() editStartDate: Date;
  @Input() editStartTime: any;
  constructor(
    private providerService: ProviderManagementService,
    private authStore: AuthStore,
    private laodingService: LoadingService,
    private formBuilder: FormBuilder
  ) {
    super();
    this.authStore.UserInfo$.pipe(filter((user: User) => !!user)).subscribe(
      (userInfo: User) => {
        this.user = userInfo;
      }
    );
    this.initializeForm();
  }

  initializeForm(): FormGroup {
    return (this.schedulesFormGroup = this.formBuilder.group({
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      startTime: new FormControl(null),
      endTime: new FormControl(null),
    }));
  }

  ngOnInit(): void {

    if (this.selectionCompare) {
      this.getCompareMandateDetails();
    }
    // if (!this.isNew) {
    //   this.getPAMeetingDetails();
    // } else {
    //   this.getCompareMandateDetails();
    // }
    this.providerService.setBindScheduleDetails(null);

    this.initWatches();
  }
  // getPAMeetingDetails(): void {
  //   this.providerService
  //     .getPAMeeting(this.meetingSk)
  //     .pipe(
  //       takeUntil(this.componentDestroyed),
  //       finalize(() => this.laodingService.hide())
  //     )
  //     .subscribe({
  //       next: (res: IProviderMeetingDetails) => {
  //         if (res) {
  //           this.editMandateIds = res?.Mandates;
  //           this.editAssessments = res?.Assignments;
  //           this.getCompareMandateDetails();
  //         }

  //       },

  //     });
  // }

  initWatches(): void {
    // Initialize any necessary watches or subscriptions here
    //Form Controls:
    const startTimeControl: FormControl = this.schedulesFormGroup.get(
      'startTime'
    ) as FormControl;
    const endTimeControl: FormControl = this.schedulesFormGroup.get(
      'endTime'
    ) as FormControl;
    const startDateControl: FormControl = this.schedulesFormGroup.get(
      'startDate'
    ) as FormControl;
    //Get the time difference and fire payload when any control changes (including just the date)
    const startTime$ = startTimeControl.valueChanges.pipe(startWith(startTimeControl.value));
    const endTime$ = endTimeControl.valueChanges.pipe(startWith(endTimeControl.value));
    const startDate$ = startDateControl.valueChanges.pipe(startWith(startDateControl.value));

    combineLatest([startTime$, endTime$, startDate$]).subscribe(
      ([start, end, startDate]: [string, string, any]) => {
        if (start && end) {
          const duration: string = getTimeDiffShort(start, end);
          this.duration = duration;
        }

        const payload = {
          startDate: startDate,
          start: start,
          end: end,
          user: this.user,
          getMeetingDetails: true,
          selecteStudentdMandates: this.selecteStudentdMandates,
          selectedMandates: this.selectedMandates,
        };
        this.providerService.setScheduleTimeDetails(payload);
      }
    );

    this.providerService.bindScheduleDetails$.subscribe((details: any) => {
      if (details?.isSelected) {
        this.schedulesFormGroup.patchValue({
          startDate: details.start,
          startTime: details.start,
          endTime: details.end,
        });
        this.providerService.setScheduleDetails(null)
      } else {
        this.providerService.setScheduleDetails(this.scheduleFormDetails)
      }
    });
  
  }
  getCompareMandateDetails(): void {
    this.laodingService.show();
    const mandateSks: string[] = this.editSelectedMandates ? this.selectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.mandateSk;
      }) :
      this.selectedMandates ? this.selectedMandates?.map(
        (res: DashboardPMResponse) => {
          return res.mandateSk;
        }
      ) : this.editMandateIds

    const AssessmentSk: string[] = this.editSelectedMandates ? this.selectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.assignmentSk;
      }) : this.selectedMandates ? this.selectedMandates?.map(
        (res: DashboardPMResponse) => {
          return res.assignmentSk;
        }
      ) : this.editAssessments;
    const studentSks: string[] = this.editSelectedMandates ? this.selectedMandates?.map(
      (res: DashboardPMResponse) => {
        return res.studentSK;
      }) : this.selectedMandates?.map(
        (res: DashboardPMResponse) => {
          return res.studentSK;
        }
      );
    const payload: ICompareMandatesPaylaod = {
      providerSk: this.user.personSk,
      mandateSks: mandateSks,
      studentSks: studentSks,
      assignmentSks: AssessmentSk,
    };
    this.providerService
      .getCompareMandates(payload)
      .pipe(
        takeUntil(this.componentDestroyed),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: (res: IMandatesCompareResponse) => {
          this.compareMandatesGridView = res.mandateAssignmentCompare;
          this.annualGoalsGridView = res.getStudentAnualGoals;
          this.laodingService.hide();
        },
      });
  }

  override afterOnDestroy(): void {
    //
  }

  removeMandate(rowIndex: number): void {
    this.compareMandatesGridView.splice(rowIndex, this.indexNumberOne);
    this.compareMandatesGridView = [...this.compareMandatesGridView];
  }

  removeAnnualGoals(rowIndex: number): void {
    this.annualGoalsGridView.splice(rowIndex, this.indexNumberOne);
    this.annualGoalsGridView = [...this.annualGoalsGridView];
  }
  public getDateRangeDisplay(dateRange: string): string {
    if (!dateRange) {
      return '';
    }

    let dates = dateRange.match(/\d{2}-\d{2}-\d{4}/g);

    if (dates?.length) {
      const formatDate = (date: string): string => {
        const [day, month, year] = date.split('-');
        return `${month}/${day}/${year}`;
      };

      return dates.length > 1
        ? `${formatDate(dates[0])} - ${formatDate(dates[1])}`
        : `${formatDate(dates[0])} - `;
    }

    dates = dateRange.match(/\d{1,2}\/\d{1,2}\/\d{4}/g);

    if (dates?.length) {
      return dates.length > 1
        ? `${dates[0]} - ${dates[1]}`
        : `${dates[0]} - `;
    }

    return '';
  }
}
